import { useBaseUrlStore, useLabels } from 'src/StoreDataProvider';
import CustomLink from '../CustomLink';
import { CustomLinkType } from '../CustomLink/customLink.types';
import { BannerProps } from './banner.types';

const Banner: (props: BannerProps) => JSX.Element = ({ picture }) => {
  const labels = useLabels();
  const { path } = useBaseUrlStore();

  return (
    <section className="detail-navigation-section">
      <div>
        <CustomLink
          className="navigate navigate__back"
          label={labels.backToSearchResults}
          type={CustomLinkType.nav}
          to={`/${path}`}
          icon={'icon-pfeil-links'}
        />
        {picture ? (
          <div>
            <img
              id="img-banner"
              className="img-banner"
              src={'data:image/jpg;base64,' + picture.imageSrc}
              alt={picture.imageAlt}
            />
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Banner;
